import { render, staticRenderFns } from "./CommonSummaryItem.vue?vue&type=template&id=5d9c98f8"
import script from "./CommonSummaryItem.vue?vue&type=script&lang=js"
export * from "./CommonSummaryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports